import { settingPageColors } from "@octopus-settings/constants/ui/colors";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  settingsPage: {
    backgroundColor: settingPageColors.background,
    border: `1px solid ${settingPageColors.border}`,
    borderTop: 0,
    display: "flex",
    flex: 1,
    flexDirection: "column",
    height: "100%",
    margin: 0,
    minHeight: 0,
    padding: 0,
    width: "100%",
  },
  settingsContent: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    minHeight: 0,
    width: "100%",
  },
}));

export default useStyles;
